// import firebaseAxios from '@/shared/firebase/firebase-axios';
/* eslint-disable */
export default {
  fetch(lastmodified) {
    // return firebaseAxios().then((axios) =>
    //   axios
    //     .get(`/positions/history`, {
    //       params: { lastmodified }
    //     })
    //     .then((response) => response.data)
    // );
  }
};



// WEBPACK FOOTER //
// ./src/entities/position/position-history/position-history-full/position-history-full-service.js